import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-p2w-waiting',
    templateUrl: './usc-p2w-waiting.component.html',
    styleUrls: ['./usc-p2w-waiting.component.css']
})
export class UscP2wWaitingComponent implements OnInit {

    p2wReadySub: Subscription;

    constructor(
        public uscStoreService: UscStoreService,
    ) { }

    ngOnInit() {
        this.p2wReadySub = this.uscStoreService.p2wReady.subscribe(r => {
            if (r) {
                this.uscStoreService.setCurrentView(this.uscStoreService.view_plan_2_win);
            }
        })
    }

    ngOnDestroy() {
        if (this.p2wReadySub) this.p2wReadySub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-waiting/usc-p2w-waiting.component.ts